module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("76LmD"))).then(() => parcelRequire('iDabs'));